import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { Mic, Twitter, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  
  return (
    <footer className="py-20 border-t border-gray-800 bg-black text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center space-y-8">
          <div className="flex items-center space-x-2">
            <Mic className="h-6 w-6" />
            <span className="text-xl font-semibold font-['Inria_Serif']">SpeakclearlyAI</span>
          </div>
          <a href="mailto:team@clearspeak.ai" className="text-gray-400 hover:text-white transition-colors">
            team@speakclearly.xyz
          </a>
          <div className="flex space-x-8">
            <Link 
              to="/products" 
              onClick={(e) => {
                if (location.pathname === '/') {
                  e.preventDefault();
                  const element = document.getElementById('features');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }
              }}
              className="text-gray-400 hover:text-white transition-colors"
            >
              Products
            </Link>
            <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">
              Pricing
            </Link>
            <Link to="/privacy_policy.html" className="text-gray-400 hover:text-white transition-colors">
              Privacy policy
            </Link>
          </div>
          <a 
            href="https://www.producthunt.com/posts/speakclearlyai?embed=true&utm_source=badge-featured&utm_medium=badge&utm_souce=badge-speakclearlyai" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img 
              src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=833048&theme=light&t=1738218482436" 
              alt="SpeakclearlyAI - AI-POWERED FILLER WORD REMOVAL & BACKGROUND NOISE CLEANUP | Product Hunt" 
              style={{ width: "250px", height: "54px" }} 
              width="250" 
              height="54" 
            />
          </a>
          <a href="https://www.uneed.best/tool/speakclearlyai">
            <img src="https://www.uneed.best/EMBED3B.png" alt="Uneed Embed Badge" />
          </a>
          <div className="flex space-x-6">
            <Link to="https://x.com/speakclearlyai" className="text-gray-400 hover:text-white transition-colors">
              <Twitter className="h-5 w-5" />
            </Link>
            <Link to="https://x.com/speakclearlyai" className="text-gray-400 hover:text-white transition-colors">
              <Linkedin className="h-5 w-5" />
            </Link>
            <Link to="https://www.youtube.com/@SpeakclearlyAI" className="text-gray-400 hover:text-white transition-colors">
              <Youtube className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;